import { Project, ProjectService } from "@/services/project-service";
import { useEffect, useState } from "react";
import {  useOutletContext, useParams } from "react-router";
import ProjectForm from "@/components/project/project-form";
import type { LayoutContext } from "@/lib/models";
import Header from "@/components/Header";
import { CacheService } from "@/services/CacheService";
import { appConfig } from "@/lib/AppConfig";

const ProjectEditPage: React.FC = () => {
  const { setPageName } = useOutletContext<LayoutContext>();
  const params = useParams();
  const [project, setProject] = useState(new Project("", "", params.siteId!, "68b4704749b0f309d2a4af2a", "68b4770949b0f309d2a4af39", 0, 0, null, null))
  
  useEffect(() => {
    const initPage = async () => {
      const project = await ProjectService.getById(params.projectId!)
      setProject(project)
      setPageName(`${project.name} - Details`) // Set the page name when the component mounts
      CacheService.clear(appConfig.resourceTypes.project, project.id!);
    }
    initPage()
  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

    return (
    <div className="container mx-auto p-4">
      <Header headerTitle={`Project: ${project.name}`} />
      <ProjectForm 
        project={project}
        onSave={async project => {
          await ProjectService.update(params.projectId!, project)
          setProject(project)
        }}
      />
    </div>)
}

export default ProjectEditPage;
